"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PropertyCardMLSLogoMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _Image = require("../../components/Image/Image.styles");
var _spaceMixin = require("../spaceMixin");
/** @class PropertyCardMLSLogoMixin */
/** @method */
var PropertyCardMLSLogoMixin = function PropertyCardMLSLogoMixin(props) {
  return (0, _styledToken.default)({
    maxHeight: 'PropertyCard.mls.logo.maxHeight',
    maxWidth: 'PropertyCard.mls.logo.maxWidth'
  }, function (_ref) {
    var maxHeight = _ref.maxHeight,
      maxWidth = _ref.maxWidth;
    return (0, _styledComponents.css)(["display:grid;grid-area:mls-logo;justify-items:end;padding:", ";", "{max-height:", "px;max-width:", "px;}"], (0, _spaceMixin.spaceMixin)(0.5)(props), _Image.StyledImage, maxHeight, maxWidth);
  })(props);
};
exports.PropertyCardMLSLogoMixin = PropertyCardMLSLogoMixin;